import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { DICTS } from "@/lib/i18n";

export const Route = createFileRoute("/account/wishlist")({
  component: lazyRouteComponent(() => import("./-pages/account.wishlist")),
  head: () => ({
    meta: [
      { title: DICTS.en["account.wishlist.meta.title"] },
      { name: "description", content: DICTS.en["account.wishlist.meta.description"] },
      { property: "og:title", content: DICTS.en["account.wishlist.meta.title"] },
      { property: "og:description", content: DICTS.en["account.wishlist.meta.description"] },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
